import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=3e7b2976&"
import script from "./Preferences.vue?vue&type=script&lang=js&"
export * from "./Preferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e7b2976')) {
      api.createRecord('3e7b2976', component.options)
    } else {
      api.reload('3e7b2976', component.options)
    }
    module.hot.accept("./Preferences.vue?vue&type=template&id=3e7b2976&", function () {
      api.rerender('3e7b2976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fimalac/components/Modal/Preferences.vue"
export default component.exports